import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sort-down",
  "use": "icon-sort-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"sortDownIconTitle\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-linejoin=\"miter\" fill=\"none\" id=\"icon-sort-down\"> <title id=\"icon-sort-down_sortDownIconTitle\">Sort in descending order</title> <path d=\"M11 9H17\" /> <path d=\"M11 5H19\" /> <path d=\"M11 13H15\" /> <path d=\"M10 17L7 20L4 17\" /> <path d=\"M7 5V19\" /> </symbol>"
});
var result = sprite.add(symbol);
export default symbol